import { render, staticRenderFns } from "./ServiceResponsibleBonusesTable.vue?vue&type=template&id=6525aa2e&"
import script from "./ServiceResponsibleBonusesTable.vue?vue&type=script&lang=js&"
export * from "./ServiceResponsibleBonusesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports